import {Pipe} from "@angular/core";
import {DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl} from "@angular/platform-browser";

@Pipe({ name: "safe" })
export class SafePipe {

    private sanitizer: DomSanitizer;
    constructor(sanitizer: DomSanitizer) {
        this.sanitizer = sanitizer;
    }

    transform(style) {
        return this.sanitizer.bypassSecurityTrustStyle(style);
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/safe.pipe.ts